<template>
  <div style="max-width:600px;margin:0 auto;background:#fff;">
    <div v-if="!detail_success">
      <div class="header">
        <div class="title">{{questionnaire_name}}</div>
      </div>
      <div class="content_body clsSatisfaction" v-if="!is_success" style="padding-top: 0 !important;">
        <el-form ref="model" :model="model">
            <!-- 表单问题 -->
            <div v-for="(item,index) in cls_infos" :key="index+'cls_infos'">
              <div class="cls_title">
                <span>{{ item.class_name }}</span> 
                <span style="margin: 0 5px;">—</span>
                <span style="color: #409eff;">{{ item.teacher_name }}</span> 
              </div>
              <el-form-item v-for="(value,key) in item.questions" :key="key+'questions'" style="margin-bottom: 10px;padding:5px 10px;">
                <div class="options" >
                    <div class="options_title">
                      <span style="margin-right: 5px;" class="option_red" v-if="value.question_mandatory == 0">*</span>
                      <span>{{value.question_text}} </span>
                      <label v-if="value.question_type == 0 || value.question_type == 1">({{value.question_type_str}})</label>
                    </div>
                    <div v-if="value.question_type == 0">
                      <el-radio-group v-model="value.ans">
                        <div class="radioGroupDiv" v-for="(option,idx) in value.choices_list" :key="idx+'choices_list'" >
                          <el-radio :label="option.id">{{option.choice_text}}</el-radio>
                        </div>
                      </el-radio-group>
                    </div>
                    <div v-else-if="value.question_type == 1">
                      <el-checkbox-group v-model="value.ans">
                        <div class="radioGroupDiv" v-for="(option,idx) in value.choices_list" :key="idx+'choices_list_more'">
                          <el-checkbox :label="option.id">{{option.choice_text}}</el-checkbox>
                        </div>
                      </el-checkbox-group>
                    </div>
                    <div v-else-if="value.question_type == 2">
                      <el-input type="textarea" v-model="value.ans" :autosize="{ minRows: 6}" class="text_ipt"></el-input>
                    </div>
                  </div>
              </el-form-item>
            
            </div>
        </el-form>
        <div class="submit_div">
          <el-button type="primary" @click="getSubmit" style="width:80%;">提交</el-button>
        </div>
      </div>
      <div class="content_success" v-else>
          <div class="success_box"><span class="el-icon-success"></span></div>
          <div class="success_title">提交成功</div>
          <div class="success_text">感谢您填写问卷，您的意见非常宝贵！</div>
      </div>
    </div>
    <div v-if="detail_success" style="height: 100vh;display: flex;align-items: center;justify-content: center;">
      <el-empty :description="detail_success_text"></el-empty>
    </div>
  </div>
</template>
<style>
  .el-select-dropdown{
    width: 96%!important;
    left: 2% !important;
  }
  .content_body .el-radio{
    display: flex;
    align-items: center;
  }
  .content_body .el-radio__label{
    display: inline-block;
    width: 96%;
    white-space: break-spaces;
    line-height: 24px;
  }
</style>
<script>
import {clsSatisfactionDetail,clsSatisfactionSubmit} from "@/api/wxApp";
export default {
  name: "clsSatisfaction",
  data() {
    return {
      is_success:false,
      model:{},
      cls_infos:[],
      questionnaire_name:'',
      detail_success:false,
      detail_success_text:'暂无数据',
    };
  },
  created() {
    this.cls_satisfaction_id = this.$route.query.cls_satisfaction_id;
    this.cid = this.$route.query.cid;
    this.getDetail();
  },
  methods: {
    getDetail(){
      let self = this;
      let data = {
        cls_satisfaction_id:self.cls_satisfaction_id,
        cid:self.cid,
      }
      clsSatisfactionDetail(data).then(response=>{
            if(response.code == 0){
              let data = response.data;
							self.questionnaire_name = data.questionnaire_name;
							self.cls_infos = [];
							let list = data.cls_infos;
							for(var i = 0;i<list.length;i++){
								for(var k = 0;k<list[i].questions.length;k++){
									list[i].questions[k].ans = [];
									if(list[i].questions[k].question_type == 0){
										list[i].questions[k].ans = '';
									}else if(list[i].questions[k].question_type == 1){
										list[i].questions[k].ans = [];
									}else if(list[i].questions[k].question_type == 2){
										list[i].questions[k].ans = '';
									}
								}
							}
							self.cls_infos = list;
            }else{
              self.detail_success = true;
              self.detail_success_text = response.msg;
              // self.$message({
              //     type: "error",
              //     duration: 2000,
              //     message:  response.msg
              // });
            }
      })
    },
    getSubmit(){
        let list = this.cls_infos;
				let cls_infos = [];
				for(var i = 0;i<list.length;i++){
					cls_infos.push({
						cls_id:list[i].cls_id,
						answers:[]
					})
					for(var k = 0;k<list[i].questions.length;k++){
            if(list[i].questions[k].question_mandatory == 0){
              if(list[i].questions[k].ans == ''){
                this.$message({type: "error",message:'请完整填写调查问卷'});
                return false;
              }
            }
						let item = {
								id:list[i].questions[k].id,
								answer:list[i].questions[k].ans
							}
						cls_infos[i].answers.push(item)
					}
				}
        let data = {
          cls_infos:cls_infos,
          cid:this.cid,
          cls_satisfaction_id:this.cls_satisfaction_id,
        }
        let self = this;
        clsSatisfactionSubmit(data).then(response=>{ 
          if(response.code == 0){
            this.$message({
                type: "success",
                duration: 2000,
                message:  response.msg,
                onClose:()=>{
                  self.is_success = true;
                }
            });
          }else{
            this.$message({
                type: "error",
                duration: 2000,
                message:  response.msg
            });
          }
        })
    },
  }
};
</script>

<style scoped>
  @import "../static/css/questionnaire.css";
</style>
<style>
  .clsSatisfaction .el-radio{
    color: #333 !important;
  }
  .clsSatisfaction .el-checkbox{
    color: #333 !important;
  }
</style>